// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}", ""]);
// Exports
module.exports = exports;
